import { Icon, IconName } from '@usealloy/component-library';
import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { UserContext } from '~/dashboard/context';
import { routes } from '~/helpers/routes';

import { Sidebar } from '../component/Sidebar';
import { useLocalStorage } from '../component/hooks/useLocalStorage';
import { isPrefixActive } from './routeMatchers';

// ============================================================
//     COMPONENTS
// ============================================================
/**
 * "Reports" nav group — SARs and CTRs.
 */
export const ReportsGroup = () => {
  const { agent, featureFlags, permissions } = useContext(UserContext);
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useLocalStorage('SideNav.Reports.isOpen', true, {
    isValid: value => typeof value === 'boolean',
  });

  const showSarsLink = featureFlags?.sarReport
    && (featureFlags?.reportingPermissions
      ? permissions?.['READ:SarReports:sar_report_id']
      : permissions?.['READ:SarReports:null'])
    && !agent?.isEmployee;
  const showCtrsLink = featureFlags?.currencyTransactionReports
    && permissions?.['READ:CtrReports:null'];

  if (!showSarsLink && !showCtrsLink) return null;

  return (
    <Sidebar.Group collapsible onOpenChange={setIsOpen} open={isOpen}>
      <Sidebar.GroupLabel>
        <span className="fs-unmask">Reports</span>
      </Sidebar.GroupLabel>
      <Sidebar.GroupContent>
        <Sidebar.Menu>
          {showSarsLink && (
            <Sidebar.MenuItem>
              <Sidebar.MenuButton
                as={Link}
                data-dd-action-name="alloydd-sidebar-nav-sars"
                isActive={isPrefixActive(routes.sars.list, pathname)}
                to={routes.sars.list}
                tooltip="SARs"
              >
                <Icon icon={IconName.Files} size="large" />
                <span className="fs-unmask">SARs</span>
              </Sidebar.MenuButton>
            </Sidebar.MenuItem>
          )}

          {showCtrsLink && (
            <Sidebar.MenuItem>
              <Sidebar.MenuButton
                as={Link}
                data-dd-action-name="alloydd-sidebar-nav-ctrs"
                isActive={isPrefixActive(
                  routes.v3.dashboard.ctrs.list,
                  pathname,
                )}
                to={routes.v3.dashboard.ctrs.list}
                tooltip="CTRs"
              >
                <Icon icon={IconName.FileInvoiceDollar} size="large" />
                <span className="fs-unmask">CTRs</span>
              </Sidebar.MenuButton>
            </Sidebar.MenuItem>
          )}
        </Sidebar.Menu>
      </Sidebar.GroupContent>
    </Sidebar.Group>
  );
};
